import React from "react";
import { HeartFilled } from "@ant-design/icons";
import { HeartStyle } from "../data/data";
import Story from "../../utils/images/the-story.jpg";
import styled from "styled-components";
const Layout = styled.div`
  color: #ffffff;
  .marry {
    font-size: 35px;
    text-transform: uppercase;
    padding-bottom: 20px;
    font-family: "Osward" sans-serif;
    text-align: center;
    @media (max-width: 766px) {
      font-size: 179%;
      padding: 12px 0;
    }
  }
  .circle {
    display: grid;
    place-items: center;
    width: 120px;
    height: 120px;
    border: 1px solid white;
    border-radius: 50%;
  }
`;
function MarryMe() {
  return (
    <>
      <Layout>
        <div style={styles.bgParallax}>
          <span className="circle">
            <HeartFilled style={{ fontSize: 35, color: "red" }} />
          </span>
          <div className="marry">marry me Ufedo</div>
          <div>
            <HeartStyle>
              <span className="white-line"></span>
              <HeartFilled style={{ fontSize: 19, zIndex: 20, color: "red" }} />
              <HeartFilled
                style={{
                  fontSize: 19,
                  marginLeft: -5,
                  color: "white",
                }}
              />
              <span className="white-line"></span>
            </HeartStyle>
          </div>
        </div>
      </Layout>
    </>
  );
}

const styles = {
  bgParallax: {
    background: `url(${Story})`,
    height: 550,
    backgroundPosition: "center",
    backgroundSize: "cover",
    objectFit: "cover",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: 53,
  },
};
export default MarryMe;
